import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { filter } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';
import { map } from 'rxjs/operators';
import { inject } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthService } from '@services/auth.service';

export const startGuardFn = (
  activatedRoute: ActivatedRouteSnapshot,
  routerState: RouterStateSnapshot
) => {
  const msalService = inject(MsalService);
  const authService = inject(AuthService);
  const broadcastService = inject(MsalBroadcastService);
  return broadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    map(() => {
      const user = msalService.instance.getActiveAccount();
      if (!user || user.idTokenClaims === undefined) {
        return true;
      } else {
        window.location.href = window.location.origin + '/order-new/start';
        return false;
      }
    })
  );
};
